import OrderProductsReceived from '../../products/events/OrderProductsReceived';
import { EventToSideEffect } from './eventToSideEffect';
import EstimationProductsReceived from '../../products/events/EstimationProductsReceived';

const eventToSideEffectConfig: EventToSideEffect[] = [
    {
        type: [OrderProductsReceived.type, EstimationProductsReceived.type],
        fn: (): void => window.scrollTo(0, 0)
    }
];

export default eventToSideEffectConfig;



// WEBPACK FOOTER //
// ./src/application/core/middleware/eventToSideEffectConfig.ts